import React from 'react'
import PropTypes from 'prop-types'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'

const errorConfig = {
  title: 'Error',
  text: 'Sorry! An error has occurred. Please contact our support team.',
}

const successConfig = {
  title: 'Success!',
  text: 'Your review request was successfully sent.',
}

const SendSuccessModal = ({ setOpen, setStep, error }) => {
  const { title, text } = error ? errorConfig : successConfig
  const styles = useStyles()

  return (
    <>
      <DialogTitle disableTypography classes={{ root: styles.titleRoot }}>
        <Typography
          component="h2"
          variant="inherit"
          className={styles.resultTitle}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent classes={{ root: styles.content }}>
        <Typography className={styles.bodyText}>{text}</Typography>
      </DialogContent>
      <DialogActions classes={{ root: styles.actionsWrapper }}>
        <Button
          onClick={() => {
            setStep(0)
            setOpen(false)
          }}
          color="primary"
          variant="contained"
        >
          Close
        </Button>
      </DialogActions>
    </>
  )
}

SendSuccessModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  setStep: PropTypes.func,
  error: PropTypes.bool,
}

export default SendSuccessModal
